<template>
  <div class="upload container flex">
    <div :class="{phone: mobile}" class="upload-preview">
      <h1>Homework</h1>
      <h2>{{ currentUser.state.grade }} </h2>
      <p>{{ uploader.user.displayName }}</p>
      <div class="desktop-view">
        <div
          @click="toggleComposer"
          class="flex upload-menu"
          :class="{active: showComposer}">
          <p class="chip">Submit</p>
          <UploadIcon class="icon"/>
        </div>
        <div
          @click="toggleInbox"
          class="flex upload-menu"
          :class="{active: showInbox}">
          <p class="chip">Received</p>
          <DownloadIcon class="icon"/>
        </div>
        <div
          @click="toggleOutbox"
          class="flex upload-menu"
          :class="{active: showOutbox}">
          <p class="chip">Submitted</p>
          <BadgeCheckIcon class="icon"/>
        </div>
      </div>
      <div :class="{mobileview: mobile}" class="view-mobile">
        <file-upload
          v-if="showComposer"
          :uploader="currentUser.state"
          @fileuploaded="toggleOutbox"
        />
        <class-uploads
          v-if="showInbox"
          :uploader="currentUser.state"
          @messageDeleted="toggleInbox"
        />
        <learner-uploads
          v-if="showOutbox"
          :uploader="currentUser.state"
          @messageDeleted="toggleOutbox"
        />
      </div>
    </div>
    <div :class="{mobile: mobile}" class="upload-full">
      <file-upload
        v-if="showComposer"
        :uploader="currentUser.state"
        @fileuploaded="toggleOutbox"
      />
      <class-uploads
        v-if="showInbox"
        :uploader="currentUser.state"
        @messageDeleted="toggleInbox"
      />
      <learner-uploads
        v-if="showOutbox"
        :uploader="currentUser.state"
        @filedeleted="toggleComposer"
      />
    </div>
  </div>
</template>

<script>
import getPosts from '@/composables/getPosts'
import { inject, onMounted, ref, watchEffect } from 'vue'
import { UploadIcon, DownloadIcon, BadgeCheckIcon } from '@heroicons/vue/outline'
import ClassUploads from './ClassUploads.vue'
import LearnerUploads from './LearnerUploads.vue'
import FileUpload from './FileUpload.vue'

export default {
  props: ['uploader'],
  components: { UploadIcon, DownloadIcon, BadgeCheckIcon, ClassUploads, LearnerUploads, FileUpload },
  setup () {
    const filteredInboxMessages = ref(null)
    const filteredOutboxMessages = ref(null)
    const currentUser = inject('currentUser')
    const windowWidth = ref(null)
    const mobile = ref(false)
    const showComposer = ref(false)
    const showOutbox = ref(false)
    const showInbox = ref(true)
    const { myData, error, load } = getPosts()

    const toggleOutbox = () => {
      //  set toast to true('toasts')
      showOutbox.value = !showOutbox.value
      showComposer.value = false
      showInbox.value = false
      load(currentUser.state.grade + '/messages/' + currentUser.state.role)
    }

    const toggleInbox = () => {
      //  set toast to true('toasts')
      showInbox.value = !showInbox.value
      showOutbox.value = false
      showComposer.value = false
      load(currentUser.state.grade + '/reports/teacher')
    }

    const toggleComposer = () => {
      showOutbox.value = false
      showInbox.value = false
      showComposer.value = !showComposer.value
    }

    load(currentUser.state.grade + '/messages/teacher')

    watchEffect(() => {
      filteredInboxMessages.value =
        myData.value ? myData.value.filter(message => message.receiver === currentUser.state.user.displayName)
          : null
      filteredOutboxMessages.value =
        myData.value ? myData.value.filter(message => message.sender === currentUser.state.user.displayName)
          : null
    })

    const handleview = () => {
      windowWidth.value = window.innerWidth
      if (windowWidth.value <= 2600) {
        mobile.value = true
        return
      }
      mobile.value = false
    }

    onMounted(() => {
      handleview()
      window.addEventListener('resize', handleview)
    })

    return { myData, error, currentUser, filteredOutboxMessages, filteredInboxMessages, toggleComposer, showComposer, toggleOutbox, toggleInbox, showOutbox, showInbox, mobile }
  }
}
</script>

<style>
.upload {
  min-height: 60vh;
  background: #f1f1f1;
  justify-content: space-around;
  padding: 8px 4px;
  color: black;
}
.upload .upload-preview {
  background: #fff;
  flex-basis: 35%;
}
.upload .upload-full {
  background: #ddd;
  flex-basis: 60%;
  color: black;
}
.upload .icon {
  width: 24px;
}
.upload .upload-menu {
  justify-content: space-between;
  cursor: pointer;
  margin: 6px;
  padding: 3px;
  transition: 0.5s ease-in-out all;
}
.upload .upload-menu:hover {
  background: #ddd;
}
.upload .active {
  background: rgba(14, 75, 62, 0.4);
}
.upload .phone {
  flex-basis: 85%;
}
.upload .mobile {
  display: none;
}
.upload .view-mobile {
  display: none;
}
.upload .mobileview {
  display: block;
  z-index: 3;
  margin-top: 30px;
}
</style>
